import {Redirect} from "wouter"

const RequireLoggedOut = props => {
  if (props.isLogged) {
    return <Redirect to={"/dashboard"} />
  }
  return <>{props.children}</>
}

export default RequireLoggedOut
